import { render, staticRenderFns } from "./StudioList.vue?vue&type=template&id=15c5ad24&scoped=true&"
import script from "./StudioList.vue?vue&type=script&lang=js&"
export * from "./StudioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5ad24",
  null
  
)

export default component.exports